
import { inAppRedirect } from '~/utils/route-redirects';

export default {
  name: 'NotificationLike',
  props: {
    notif: {
      required: true,
      type: Object,
    },
  },
  methods: {
    goToTarget(targetId) {
      inAppRedirect(`/post/${targetId}`);
    },
  },
};
